import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface EmailPresetPickerData {
  presets: any[]; // [{ name, description, text, ... }] gruppiert nach Kategorien
}

@Component({
  selector: 'app-email-preset-picker-dialog',
  template: `
    <h2 mat-dialog-title>Preset auswählen</h2>

    <mat-dialog-content class="preset-dialog-content">
      <div class="mb-2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Suchen</mat-label>
          <input
            matInput
            [(ngModel)]="searchTerm"
            placeholder="Nach Name, Kategorie oder Beschreibung suchen"
          />
        </mat-form-field>
      </div>

      <div class="preset-list" *ngIf="filteredPresets.length; else noPresets">
        <table class="table table-hover table-sm mb-0">
          <thead>
            <tr>
              <th style="width: 25%;">Kategorie</th>
              <th style="width: 30%;">Name</th>
              <th>Beschreibung</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let preset of filteredPresets"
              (dblclick)="selectPreset(preset)"
              (click)="selectPreset(preset)"
              class="cursor-pointer"
            >
              <td>{{ preset.catName }}</td>
              <td>{{ preset.name }}</td>
              <td>{{ preset.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #noPresets>
        <p class="text-muted mb-0">Keine Presets gefunden.</p>
      </ng-template>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">Schließen</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
    .preset-dialog-content {
      max-height: 70vh;
    }
    .preset-list {
      max-height: 50vh;
      overflow: auto;
    }
    .cursor-pointer {
      cursor: pointer;
    }
    tr.cursor-pointer:hover {
      background-color: #f5f5f5;
    }
  `
  ]
})
export class EmailPresetPickerDialogComponent {
  flatPresets: { catName: string; name: string; description: string; text: string }[] = [];
  searchTerm = '';

  constructor(
    public dialogRef: MatDialogRef<EmailPresetPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmailPresetPickerData
  ) {
    const list: any[] = [];
    (data.presets || []).forEach(cat => {
      (cat.presets || []).forEach((p: any) => list.push({ catName: cat.name, ...p }));
    });
    this.flatPresets = list;
  }

  get filteredPresets() {
    const term = (this.searchTerm || '').toLowerCase().trim();
    if (!term) return this.flatPresets;
    return this.flatPresets.filter(p =>
      (p.name || '').toLowerCase().includes(term) ||
      (p.description || '').toLowerCase().includes(term) ||
      (p.catName || '').toLowerCase().includes(term)
    );
  }

  selectPreset(preset: any): void {
    this.dialogRef.close(preset);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}

